import React, {useCallback, useState, useEffect} from 'react'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom'
import Switch from '@mui/material/Switch';
import RssIcon from '@mui/icons-material/RssFeedRounded';
import EditIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import AddIcon from '@mui/icons-material/AddRounded';
import AddCircleIcon from '@mui/icons-material/AddCircleRounded';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearchRounded';
import {useDispatch, useSelector} from 'react-redux'
import endpoints, {apiRequest} from '../../../endpoints'
import axios from 'axios'
import { colors } from '../../../settings'
import Confirmation from '../modals/Confirmation';
import EditFeedModal from '../modals/EditFeedModal'
import FileCopyIcon from '@mui/icons-material/FileCopyRounded';

export default function Feeds(props) {
    const [list, setList] = useState()
    const [editItem, setEditItem] = useState(null)
    const [deleteItem, setDeleteItem] = useState(null)
    const [statusItem, setStatusItem] = useState(null)
    
    const token = useSelector((state) => state.auth.token)
    
    const getList = async () => {
        try {
            const res = await apiRequest('get', endpoints.feeds_ext, {
                token: token,
            }, false)
            setList(res.data.items)
        } catch (e) {
            setList([])
        }
    }
    
    const confirmStatusHandle = async (response) => {
        if (response) {
            try {
                const res = await apiRequest('put', endpoints.feeds_ext_status, {
                    token: token,
                    id: statusItem.id,
                    status: statusItem.status != 'active' ? 'active' : 'inactive',
                })
                await getList()
            } catch (e) {
                //
            }
        }
        setStatusItem(null)
    }
    
    const confirmDeleteHandle = async (response) => {
        if (response) {
            try {
                const res = await apiRequest('delete', endpoints.feeds_ext_delete, {
                    token: token,
                    id: deleteItem.id,
                })
                await getList()
                
                // Dispatch for update
                window.dispatchEvent(new Event('FEEDS_UPDATED'));
            } catch (e) {
                
            }
        }
        setDeleteItem(null)
    }
    
    const saveHandle = (data) => {
        setEditItem(null)
        getList()
        
        // Dispatch for update
        window.dispatchEvent(new Event('FEEDS_UPDATED'));
    }
    
    const cloneFeed = (data) => {
        let copy = Object.assign({}, data)
        copy.id = null
        copy.name += ' (COPY)'
        copy.cloning = true
        
        let context = data.finder.context
        let filter =  data.finder.filter
        let instructions = []
        
        let i = -1;
        data.finder.instructions.forEach(function (item) {
            instructions.push({
                id: i--,
                context: item.context,
                result_invert: item.result_invert,
                type: item.type,
            })
        })
        
        copy.finder = {
            context: context,
            filter: filter,
            instructions: instructions,
        }
        
        console.log(copy)
        
        setEditItem(copy)
    }
    
    const feedsUpdateHandler = () => {
        getList()
    }
    
    useEffect(() => {
        getList()
        window.removeEventListener('FEEDS_UPDATED', feedsUpdateHandler)
        window.addEventListener('FEEDS_UPDATED', feedsUpdateHandler)
    }, [])
    
    return (
        <Paper sx={{minHeight:270}}>
            <Stack>
                <Stack direction="row" sx={{flexGrow:1, pl:3, pr:2, pt:2}} alignItems="center">
                    <Typography variant="subtitle1" sx={{flexGrow:1}}>
                        Feeds
                    </Typography>
                </Stack>
                <List>
                    {list?.map((row) => (
                        <ListItem
                            key={row.id}
                            disablePadding
                            secondaryAction={
                                <Stack direction="row" alignItems="center" spacing={0}>
                                    <Switch
                                        edge="end"
                                        size="small"
                                        onChange={() => {setStatusItem(row)}}
                                        checked={row.status == 'active'}
                                        sx={{mr:1}}
                                    />
                                    <IconButton onClick={() => {setEditItem(row)}}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton onClick={() => {setDeleteItem(row)}}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Stack>
                            }
                        >
                            <ListItemButton 
                                to={`/feeds/contents/${row.id}`}
                                component={NavLink}
                            >
                                <ListItemIcon>
                                    <RssIcon />
                                </ListItemIcon>
                                <ListItemText 
                                    primary={row.name} 
                                    primaryTypographyProps={{
                                        style: {
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Stack>
            <Confirmation 
                data={statusItem} 
                onResponse={confirmStatusHandle}
                labelNo="Cancel"
                labelYes={statusItem?.status == 'active' ? 'Turn off' : 'Turn on'}
            />
            <Confirmation 
                data={deleteItem} 
                onResponse={confirmDeleteHandle} 
                content={'Delete the "' + deleteItem?.name + '" feed and all data associated with it?'} 
            />
            <EditFeedModal 
                dialogData={editItem}
                onClose={() => {setEditItem(null)} }
                onSave={saveHandle}
            />
        </Paper>
    )
}